module.exports = new __parcel__URL__("roadmap-dark.058faaaa.svg").toString();